import React, { Component, useState, useRef, useEffect, createRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import ProductCard from "./../component/ProductCard";
import BannerSkeleton from "./../component/BannerSkeleton";
import ProductCardSkeleton from "./../component/ProductCardSkeleton";
import CategorySkeleton from "./../component/CategorySkeleton";
import StoreSkeleton from "./../component/StoreSkeleton";
import HeadingSkeleton from "./../component/HeadingSkeleton";
import { Carousel } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import Slider from "react-slick";
import $ from "jquery";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NotificationManager } from "react-notifications";
import axios from "axios";
import StoreHeartIcon from "../component/StoreHeartIcon";

const carouselImg = require("./../assets/img/banner-min.png");
const storeImg = require("./../assets/img/stores1-min.png");
const storeImg2 = require("./../assets/img/stores2-min.png");
const productImg = require("./../assets/img/product1-min.png");
const productImg2 = require("./../assets/img/product2-min.png");
const wishlistImg = require("./../assets/img/wishlist-icon2.svg").default;
const cartImg = require("./../assets/img/cart-icon.svg").default;
const categoryImg1 = require("./../assets/img/category1-min.png");
const categoryImg2 = require("./../assets/img/category2-min.png");
const icon1 = require("./../assets/img/icon1.svg").default;
const icon2 = require("./../assets/img/icon2.svg").default;
const icon3 = require("./../assets/img/icon3.svg").default;
const icon4 = require("./../assets/img/icon4.svg").default;

const Home = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedLanguage, langJson } = useLanguage();
  const sliderRef = createRef();
  const sliderCatRef = createRef();
  const wishlistedSliderRef = createRef();
  const recentlyViewedSliderRef = createRef();
  const topSellingSliderRef = createRef();
  const newArrivalSliderRef = createRef();

  const [bannerList, setBannerList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [shopCategoryList, setShopCategoryList] = useState([]);
  const [wishBtn, setWishBtn] = useState(false);
  const [wishMsg, setWishMsg] = useState(false);
  const [openModal, setOpenModal] = useState();
  const [topSellingProducts, setTopSellingProducts] = useState([]);
  const [newArivalasData, setNewArivalasData] = useState([]);
  const [recentlyViewedData, setRecentlyViewedData] = useState([]);
  const [wishlistedData, setWishlistedData] = useState([]);
  const [products, setProducts] = useState();
  const [loadingHomeProducts, setLoadingHomeProducts] = useState(true);
  const [loadingGeneral, setLoadingGeneral] = useState(true);
  const [storeWishlistLoadingId, setStoreWishlistLoadingId] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [loadingBlogs, setLoadingBlogs] = useState(true);


  // Only enable the infinite category carousel when there are enough
  // categories to scroll. With a short list, react-slick can clone items
  // and make a single category appear twice.
  const categoryCount = shopCategoryList?.length || 0;
  const settingsCat = {
    dots: false,
    infinite: categoryCount > 6,
    speed: 500,
    slidesToShow: Math.min(7, Math.max(1, categoryCount || 1)),
    slidesToScroll: 1,
    asNavFor: sliderCatRef.current,
    arrows: categoryCount > 1,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: Math.min(6, Math.max(1, categoryCount || 1)),
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(5, Math.max(1, categoryCount || 1)),
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(3, Math.max(1, categoryCount || 1)),
        },
      },
    ],
  };

  const settingStore = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: sliderRef.current,
    arrows: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // Adjust the breakpoint value based on your design needs
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };



  const wishlistedSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: wishlistedSliderRef.current,
    arrows: true,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const recentlyViewedSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: recentlyViewedSliderRef.current,
    arrows: true,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const topSellingSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: recentlyViewedSliderRef.current,
    arrows: true,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const newArrivalSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: recentlyViewedSliderRef.current,
    arrows: true,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const fetchAllData = async () => {
    try {
      setLoadingGeneral(true);

      // Define the URLs for your API requests
      const bannersUrl = `${API_BASE_URL}frontend/banners`;
      const featuredStoresUrl = `${API_BASE_URL}frontend/featured-stores`;
      const featuredCategoriesUrl = `${API_BASE_URL}frontend/featured-categories`;

      // Make multiple requests concurrently using axios.all and Promise.all
      const [bannersResponse, storesResponse, categoriesResponse] = await axios.all([
        axios.get(bannersUrl),
        axios.get(featuredStoresUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.authorisation?.token}`,
          },
        }),
        axios.get(featuredCategoriesUrl),
      ]);

      // Handle each response individually
      if (bannersResponse.data.res === true) {
        setBannerList(bannersResponse.data.data);
      }

      if (storesResponse.data.res === true) {
        setStoreList(storesResponse.data.data);
      }

      if (categoriesResponse.data.res === true) {
        setShopCategoryList(categoriesResponse.data.data);
      }
    } catch (error) {
      // Handle errors
      console.error("Error:", error);
    } finally {
      setLoadingGeneral(false);
    }

  };

  const fetchHomeProducts = async () => {
    try {
      setLoadingHomeProducts(true);
      const response = await fetch(`${API_BASE_URL}frontend/home-products`, {
        headers: {
          Authorization: `Bearer ${user?.authorisation?.token}`,
        },
      });
      const responseData = await response.json();
      console.log(responseData);
      if (responseData?.res === true) {
        console.log(responseData.data);
        setTopSellingProducts(responseData.data.top_selling || []);
        setNewArivalasData(responseData.data.new_arrivals || []);
        setRecentlyViewedData(responseData.data.recently_viewed || []);
        setWishlistedData([]);
        setProducts(responseData.data.wishlisted || []);
        console.log("Home Products Data:", response.data);
      }
    } catch (error) {
      console.log("Home Products API Error:", error?.response?.status, error?.response?.data);
    } finally {
      setLoadingHomeProducts(false);
    }
  };

  const updateWishlistInList = (listSetter) => (productId, wishlistId) => {
    listSetter(prev =>
      prev.map(p =>
        p.product_id === productId ||
          p.colors?.some(c => c.product_id === productId)
          ? { ...p, wishlist_id: wishlistId }
          : p
      )
    );
  };

  const handleAddWishlist = async (productId) => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      setWishMsg(null);
      setWishBtn(true);
      try {
        const response = await fetch(`${API_BASE_URL}frontend/wishlists`, {
          method: "POST",
          body: JSON.stringify({
            product_id: productId,
            lang: selectedLanguage,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.authorisation?.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          setWishMsg(responseData.msg);
          NotificationManager.success(responseData.msg);
          return responseData?.data?.wishlist?.id || null;
        } else {
          setWishMsg(responseData.msg);
          NotificationManager.warning(responseData.msg);
          return null;
        }
        setTimeout(() => {
          setWishMsg(null);
        }, 5000);
      } catch (error) {
        console.error("Error during Sign UP:", error);
        return null;
      }
    }
  };

  const addWishlistAndUpdate = async (productId, setList) => {
    const wishlistId = await handleAddWishlist(productId);
    if (!wishlistId) return;

    setList(prev =>
      prev.map(p =>
        p.product_id === productId ||
          p.colors?.some(c => c.product_id === productId)
          ? { ...p, wishlist_id: wishlistId }
          : p
      )
    );
  };

  const handleRemoveWishlist = async (wishlistId) => {
    if (!wishlistId) return;

    try {
      const response = await fetch(
        `${API_BASE_URL}frontend/wishlists/${wishlistId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${user?.authorisation?.token}`,
          },
        }
      );

      const res = await response.json();
      if (!res.res) {
        NotificationManager.warning(res.msg);
        return false;
      }

      return true;
    } catch (error) {
      console.error("Remove wishlist error:", error);
      return false;
    }
  };


  const removeWishlistAndUpdate = async (wishlistId, setList) => {
    const ok = await handleRemoveWishlist(wishlistId);
    if (!ok) return;

    setList(prev =>
      prev.map(p =>
        p.wishlist_id === wishlistId
          ? { ...p, wishlist_id: null }
          : p
      )
    );
  };

  const getStoreFavouriteId = store =>
    store?.favourite_id ?? store?.favorite_id ?? store?.liked_store_id ?? null;

  const updateStoreFollowState = (storeId, favouriteId) => {
    setStoreList(prevStores =>
      (prevStores || []).map(store =>
        Number(store?.id) === Number(storeId)
          ? {
            ...store,
            favourite_id: favouriteId,
            favorite_id: favouriteId,
            liked_store_id: favouriteId,
          }
          : store
      )
    );
  };

  const handleToggleStoreWishlist = async (event, store) => {
    event.preventDefault();
    event.stopPropagation();

    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
      return;
    }

    if (storeWishlistLoadingId) return;

    const storeId = store?.id;
    const previousFavouriteId = getStoreFavouriteId(store);
    const isFollowing = Boolean(previousFavouriteId);

    setStoreWishlistLoadingId(storeId);
    updateStoreFollowState(storeId, isFollowing ? null : "pending");

    try {
      let response;

      if (isFollowing && previousFavouriteId) {
        response = await fetch(`${API_BASE_URL}frontend/liked-stores/${previousFavouriteId}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${user?.authorisation?.token}`,
          },
        });
      } else {
        response = await fetch(`${API_BASE_URL}frontend/liked-stores`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.authorisation?.token}`,
          },
          body: JSON.stringify({ store_id: storeId }),
        });
      }

      const responseData = await response.json();
      if (!responseData?.res) {
        throw new Error(responseData?.msg || "Something went wrong");
      }

      const updatedFavouriteId =
        isFollowing
          ? null
          : responseData?.favourite_id ?? responseData?.data?.favourite_id ?? responseData?.data?.id ?? previousFavouriteId;

      updateStoreFollowState(storeId, updatedFavouriteId);
      if (!isFollowing) {
        NotificationManager.success(responseData?.msg);
      }
    } catch (error) {
      updateStoreFollowState(storeId, previousFavouriteId);
      NotificationManager.warning(error?.message || "Something went wrong");
    } finally {
      setStoreWishlistLoadingId(null);
    }
  };

  const fetchBlogs = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}blogs`);
      const responseData = await response.json();
      const list = responseData?.data?.data ?? responseData?.data ?? responseData ?? [];
      setBlogs(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoadingBlogs(false);
    }
  };

  useEffect(() => {
    // fetchBanners();
    // fetchStores();
    // fetchShopCategories();
    fetchAllData();
    fetchHomeProducts();
    fetchBlogs();
    if (user?.role === "vendor" || user?.role === "admin") {
      navigate("/dashboard");
    }
  }, []);

  return (
    <div>
      <Header openModal={openModal} />

      <div className="banner">
        {loadingGeneral ? (
          <BannerSkeleton />
        ) : (
          <Carousel>
            {bannerList?.map((item, index) => (
              <Carousel.Item key={index}>
                <img src={item?.image} alt="" />
                <div className="mainDiv">
                  <Carousel.Caption>
                    <div dangerouslySetInnerHTML={{ __html: item?.description }}></div>
                    {item?.target ? <Link to={item?.target}>{langJson?.shopnow}</Link> : null}
                  </Carousel.Caption>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        )}
      </div>

      {user && (
        <div className="storeDiv storeNew">
          <div className="fullContainer">
            <h2>
              {langJson?.welcomeback}, {user.name}
            </h2>
          </div>
        </div>
      )}

      {/* {shopCategoryList?.length > 0 ? (
        <>
          <div className="categoryDiv categoryNew">
            <div className="fullContainer">
              <h2>{langJson?.shopbycatagory}</h2>
              <Slider {...settingsCat} ref={sliderCatRef}>
                {shopCategoryList?.map((item, index) => (
                  <Link to={`/category/${item?.id}`} state={{ from: location.pathname }}>
                    <div className="categoryList" key={index}>
                      <div className="imgHolderNew">
                        <img className="d-block w-30" src={IMAGE_URL + item?.image} alt={`Store ${index}`} />
                      </div>
                      <h3>{item?.title}</h3>
                    </div>
                  </Link>
                ))}
              </Slider>
            </div>
          </div>
        </>
      ) : null} */}

      {/* {loadingGeneral ? (
        <Slider {...settingsCat}>
          {[...Array(4)].map((_, i) => (
            <CategorySkeleton key={i} />
          ))}
        </Slider>
      ) : shopCategoryList?.length > 0 ? (
        <>
          <div className="categoryDiv categoryNew categoryNewLayout">
            <div className="fullContainer">
              <h2>{langJson?.shopbycatagory}</h2>
              <Slider {...settingsCat} ref={sliderCatRef}>
                {shopCategoryList?.map((item, index) => (
                  <>
                    <Link to={`/category/${item?.id}`} state={{ from: location.pathname }}>
                      <div className="categoryLayoutList" key={index}>
                        <div className="cateLayDiv">
                          <div className="cateLayImage">
                            <img src={IMAGE_URL + item?.image} alt={`Store ${index}`} />
                          </div>
                          <h3>{langJson?.[item.slug] ?? item.title}</h3>
                        </div>

                      </div>
                    </Link >
                  </>
                ))}
              </Slider>
            </div>
          </div>
        </>
      ) : null
      } */}

      <div className="categoryDiv categoryNew categoryNewLayout">
        <div className="fullContainer">
          {loadingGeneral ? (
            <HeadingSkeleton width="220px" height="32px" />
          ) : (
            <h2>{langJson?.shopbycatagory}</h2>
          )}

          {loadingGeneral ? (
            <Slider {...settingsCat}>
              {[...Array(5)].map((_, i) => (
                <CategorySkeleton key={i} />
              ))}
            </Slider>
          ) : shopCategoryList?.length > 0 ? (
            <Slider {...settingsCat} ref={sliderCatRef}>
              {shopCategoryList.map((item, index) => (
                <Link
                  key={item?.id ?? `category-${index}`}
                  to={`/category/${item?.id}`}
                  state={{ from: location.pathname }}
                >
                  <div className="categoryLayoutList">
                    <div className="cateLayDiv">
                      <div className="cateLayImage">
                        <img
                          src={IMAGE_URL + item?.image}
                          alt={`Category ${index}`}
                        />
                      </div>
                      <h3>{langJson?.[item.slug] ?? item.title}</h3>
                    </div>
                  </div>
                </Link>
              ))}
            </Slider>
          ) : null}
        </div>
      </div>


      {/* {loadingGeneral ? (
        <Slider {...settingStore}>
          {[...Array(5)].map((_, i) => (
            <StoreSkeleton key={i} />
          ))}
        </Slider>
      ) : storeList?.length > 0 ? (
        <div className="storeDiv storeNew">
          <div className="fullContainer">
            <h2>{langJson?.ourstores}</h2>
            <div className="storetab">
            </div>
            <Slider {...settingStore} ref={sliderRef}>
              {storeList?.map((item, index) => (
                <div className="storeItem" key={index}>
                  <Link to={`/stores/${item?.id}`} state={{ from: location.pathname }}>
                    <div className="storeImgHolder">
                      <img className="storeItemImg" src={IMAGE_URL + item?.latest_product_image} alt={`Store ${index}`} />
                    </div>
                    <img className="storeLogo" src={IMAGE_URL + item?.logo} alt={`Store ${index}`} />
                    <h3 className="storeName">{item?.store_name}</h3>
                  </Link>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      ) : null
      } */}

      





      {(loadingBlogs || blogs.length > 0) && (
        <div className="categoryDiv productSliderMain topNew tradePrdts newsDiv">
          <div className="fullContainer">
            <div className="featureDiv productListMain">
              {loadingBlogs ? (
                <HeadingSkeleton width="120px" height="28px" />
              ) : (
                <h2 className="storeTabHdn">{langJson?.news ?? "News"}</h2>
              )}

              <ul className="products products-5-col homeNewsGrid">
                {loadingBlogs ? (
                  Array.from({ length: 5 }).map((_, i) => (
                    <ProductCardSkeleton key={i} />
                  ))
                ) : (
                  blogs.map((item, index) => (
                    <li key={index}>
                      <Link to={`/blogs/${item?.slug}`}>
                        <div className="videoHldr blogImgHldr">
                          {item?.featured_image ? (
                            <img src={IMAGE_URL + item.featured_image} alt={item?.title} />
                          ) : (
                            <div className="newsImgPlaceholder" />
                          )}
                        </div>
                        <div className="blogCardInfo">
                          {/* <span className="blogCardCategory">{langJson?.news ?? "NEWS"}</span> */}
                          <h3 className="blogCardTitle">{item?.title}</h3>
                          {item?.author && (
                            <span className="blogCardAuthor">{item.author.toUpperCase()}</span>
                          )}
                          {item?.published_at && (
                            <span className="blogCardDate">
                              {new Date(item.published_at).toLocaleDateString(undefined, {
                                day: "numeric", month: "long", year: "numeric",
                              })}
                            </span>
                          )}
                        </div>
                      </Link>
                    </li>
                  ))
                )}
              </ul>

            </div>
          </div>
        </div>
      )}

      {(loadingHomeProducts || topSellingProducts?.length > 0) && (
        <div className="categoryDiv productSliderMain topNew">
          <div className="fullContainer">
            {loadingHomeProducts ? (
              <HeadingSkeleton width="240px" height="32px" />
            ) : (
              <h2>{langJson?.topsellingproduct || "Top selling products"}</h2>
            )}

            <div
              className="featureDiv"
              style={{ background: "transparent", margin: 0, paddingTop: 0 }}
            >
              <div className="productList">

                {loadingHomeProducts ? (
                  <ul className="productGrid">
                    {[...Array(6)].map((_, i) => (
                      <ProductCardSkeleton key={i} />
                    ))}
                  </ul>
                ) : topSellingProducts?.length > 6 ? (
                  <Slider {...topSellingSliderSettings} ref={topSellingSliderRef}>
                    {topSellingProducts.map((product) => (
                      <ProductCard
                        key={product.order_no}
                        product={product}
                        handleAddWishlist={(productId) =>
                          addWishlistAndUpdate(productId, setTopSellingProducts)
                        }
                        handleRemoveWishlist={(wishlistId) =>
                          removeWishlistAndUpdate(wishlistId, setTopSellingProducts)
                        }
                        showStore={true}
                        store={product?.store}
                      />
                    ))}
                  </Slider>
                ) : (
                  <ul className="productGrid">
                    {topSellingProducts.map((product) => (
                      <ProductCard
                        key={product.order_no}
                        product={product}
                        handleAddWishlist={(productId) =>
                          addWishlistAndUpdate(productId, setTopSellingProducts)
                        }
                        handleRemoveWishlist={(wishlistId) =>
                          removeWishlistAndUpdate(wishlistId, setTopSellingProducts)
                        }
                        showStore={true}
                        store={product?.store}
                      />
                    ))}
                  </ul>
                )}

              </div>
            </div>
          </div>
        </div>
      )}


      {(loadingHomeProducts || newArivalasData?.length > 0) && (
        <div className="categoryDiv productSliderMain topNew hmeNewArrival">
          <div className="fullContainer">
            {loadingHomeProducts ? (
              <HeadingSkeleton width="180px" height="32px" />
            ) : (
              <h2>{langJson?.newarrivals || "New Arrivals"}</h2>
            )}

            <div
              className="featureDiv"
              style={{ background: "transparent", margin: 0, paddingTop: 0 }}
            >
              <div className="productList">

                {loadingHomeProducts ? (
                  <ul className="productGrid">
                    {[...Array(6)].map((_, i) => (
                      <ProductCardSkeleton key={i} />
                    ))}
                  </ul>
                ) : newArivalasData?.length > 6 ? (
                  <Slider {...newArrivalSliderSettings} ref={newArrivalSliderRef}>
                    {newArivalasData.map((product) => (
                      <ProductCard
                        key={product.order_no}
                        product={product}
                        handleAddWishlist={(productId) =>
                          addWishlistAndUpdate(productId, setNewArivalasData)
                        }
                        handleRemoveWishlist={(wishlistId) =>
                          removeWishlistAndUpdate(wishlistId, setNewArivalasData)
                        }
                        showStore={true}
                        store={product?.store}
                      />
                    ))}
                  </Slider>
                ) : (
                  <ul className="productGrid">
                    {newArivalasData.map((product) => (
                      <ProductCard
                        key={product.order_no}
                        product={product}
                        handleAddWishlist={(productId) =>
                          addWishlistAndUpdate(productId, setNewArivalasData)
                        }
                        handleRemoveWishlist={(wishlistId) =>
                          removeWishlistAndUpdate(wishlistId, setNewArivalasData)
                        }
                        showStore={true}
                        store={product?.store}
                      />
                    ))}
                  </ul>
                )}

              </div>
            </div>
          </div>
        </div>
      )}


      {(loadingHomeProducts || recentlyViewedData?.length > 0) && (
        <div className="categoryDiv productSliderMain topNew hmeNewArrival">
          <div className="fullContainer">
            {loadingHomeProducts ? (
              <HeadingSkeleton width="190px" height="32px" />
            ) : (
              <h2>{langJson?.recentlyviewed || "Recently viewed"}</h2>
            )}

            <div
              className="featureDiv"
              style={{ background: "transparent", margin: 0, paddingTop: 0 }}
            >
              <div className="productList">

                {loadingHomeProducts ? (
                  <ul className="productGrid">
                    {[...Array(6)].map((_, i) => (
                      <ProductCardSkeleton key={i} />
                    ))}
                  </ul>
                ) : recentlyViewedData?.length > 6 ? (
                  <Slider {...recentlyViewedSliderSettings} ref={recentlyViewedSliderRef}>
                    {recentlyViewedData.map((product) => (
                      <ProductCard
                        key={product.order_no}
                        product={product}
                        handleAddWishlist={(productId) =>
                          addWishlistAndUpdate(productId, setRecentlyViewedData)
                        }
                        handleRemoveWishlist={(wishlistId) =>
                          removeWishlistAndUpdate(wishlistId, setRecentlyViewedData)
                        }
                        showStore={true}
                        store={product?.store}
                      />
                    ))}
                  </Slider>
                ) : (
                  <ul className="productGrid">
                    {recentlyViewedData.map((product) => (
                      <ProductCard
                        key={product.order_no}
                        product={product}
                        handleAddWishlist={(productId) =>
                          addWishlistAndUpdate(productId, setRecentlyViewedData)
                        }
                        handleRemoveWishlist={(wishlistId) =>
                          removeWishlistAndUpdate(wishlistId, setRecentlyViewedData)
                        }
                        showStore={true}
                        store={product?.store}
                      />
                    ))}
                  </ul>
                )}

              </div>
            </div>
          </div>
        </div>
      )}


      {(loadingHomeProducts || wishlistedData?.length > 0) && (
        <div className="categoryDiv productSliderMain topNew">
          <div className="fullContainer">
            {loadingHomeProducts ? (
              <HeadingSkeleton width="170px" height="32px" />
            ) : (
              <h2>{langJson?.wishlist || "Your Wishlist"}</h2>
            )}

            <div
              className="featureDiv"
              style={{ background: "transparent", margin: 0, paddingTop: 0 }}
            >
              <div className="productList">

                {loadingHomeProducts ? (
                  <ul className="productGrid">
                    {[...Array(6)].map((_, i) => (
                      <ProductCardSkeleton key={i} />
                    ))}
                  </ul>
                ) : wishlistedData?.length > 4 ? (
                  <Slider {...recentlyViewedSliderSettings} ref={recentlyViewedSliderRef}>
                    {wishlistedData.map((product) => (
                      <ProductCard
                        key={product.order_no}
                        product={product}
                        isWishlistView={true}
                        handleRemoveWishlist={(wishlistId) =>
                          removeWishlistAndUpdate(wishlistId, setWishlistedData)
                        }
                        showStore={true}
                        store={product?.store}
                      />
                    ))}
                  </Slider>
                ) : (
                  <ul className="productGrid">
                    {wishlistedData.map((product) => (
                      <ProductCard
                        key={product.order_no}
                        product={product}
                        isWishlistView={true}
                        handleRemoveWishlist={(wishlistId) =>
                          removeWishlistAndUpdate(wishlistId, setWishlistedData)
                        }
                        showStore={true}
                        store={product?.store}
                      />
                    ))}
                  </ul>
                )}

              </div>
            </div>
          </div>
        </div>
      )}


      <div className="newsLetterDiv">
        <h2>{langJson?.getexclusiveoffersthelatesttrendstoyourinbox}</h2>
        <h3>{langJson?.dontmissout}</h3>
        <Link className="loginLink" to="">{langJson?.signupforemail}</Link>
      </div>

      <div className="provideDiv">
        <ul>
          <li>
            <img src={icon1} alt="" />
            <h3>{langJson?.easyreturn}</h3>
          </li>
          <li>
            <img src={icon2} alt="" />
            <h3>{langJson?.fastshipping}</h3>
          </li>
          <li>
            <img src={icon3} alt="" />
            <h3>{langJson?.securepayments}</h3>
          </li>
          <li>
            <img src={icon4} alt="" />
            <h3>{langJson?.friendlysupport}</h3>
          </li>
        </ul>
      </div>

      <Footer />
    </div >
  );
};

export default Home;
